module.exports = __webpack_public_path__ + "img/icon-merck-96d7d2.c5b0e3c6.svg";